import { ref } from 'vue'
import { httpService } from '../services/httpService'
import { config } from '../services/configService'
import { log } from '../utils/DebugLogger'

// Import side-effect: registers the contract with the responseContract registry.
import '../contracts/AiCredits_PurchasesResponse'

import type { AiCredits_PurchaseRow } from '../contracts/AiCredits_PurchaseRow'
import type { AiCredits_PurchasesQueryInput } from '../contracts/AiCredits_PurchasesQueryInput'

/**
 * useCreditPurchases — SOLE network owner for GET ai/credits/purchases.
 *
 * READ-ONLY staff mirror of ai_credit_purchases (M5a backend, M5b-1 frontend).
 * No reconciliation action lives here — that stays at
 * admin_sync_credit_purchases (ai/credits/admin_sync_credit_purchases).
 *
 * Endpoints:
 *   GET ai/credits/purchases  → recent purchase rows, newest-first
 */

// Module-scope singleton state
const purchases = ref<AiCredits_PurchaseRow[]>([])

function sistemaUrl(path: string): string {
  return `${config.api.sistemaHost}/${path}`
}

export function useCreditPurchases() {
  /**
   * fetchPurchases — GET ai/credits/purchases[?limit=].
   * Populates the module-scope purchases ref.
   */
  async function fetchPurchases(query: AiCredits_PurchasesQueryInput = {}): Promise<void> {
    const params = new URLSearchParams()
    if (query.limit != null) params.set('limit', String(query.limit))
    const qs = params.toString()
    const raw = await httpService.get(
      sistemaUrl('ai/credits/purchases') + (qs ? `?${qs}` : ''),
      { responseContract: 'AiCredits_PurchasesResponse' },
    )
    const resp = raw as { dados: { rows: AiCredits_PurchaseRow[] } }
    purchases.value = resp.dados?.rows ?? []
    log('useCreditPurchases', 'fetchPurchases', 'Compras carregadas', { count: purchases.value.length })
  }

  /**
   * _reset — wipes module-scope state back to initial values.
   * Call in afterEach to prevent cross-test leakage.
   */
  function _reset(): void {
    purchases.value = []
  }

  return {
    purchases,
    fetchPurchases,
    _reset,
  }
}
